import axios from 'axios';

export const getBaseUrl = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'local':
      return 'http://localhost:8083';
    case 'development':
      return 'https://client.formpiper-dev.com';
    case 'production':
    default:
      return 'https://client.formpiper.com';
  }
};

export const getBaseApiUrl = () => {
  // Allow overriding the API URL via env (e.g. the sim env); fall back to the
  // hardcoded per-environment values when not set.
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // For aggregator routes in iframe, use port 8082 (different backend)
  // For normal API calls, use port 8083
  if (typeof window !== 'undefined') {
    const isInIframe = window.self !== window.top;
    const isAggregatorRoute = window.location.pathname.includes('/aggregator/');

    // Use different port for aggregator iframe requests
    if (isInIframe && isAggregatorRoute) {
      switch (process.env.REACT_APP_ENVIRONMENT) {
        case 'local':
          return 'http://localhost:8082';
        case 'development':
          return 'https://api.formpiper-dev.com';
        case 'production':
        default:
          return 'https://api.formpiper.com';
      }
    }
  }

  // Normal behavior for all non-aggregator routes (preserves existing functionality)
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'local':
      return 'http://localhost:8083';
    case 'development':
      return 'https://client-api.formpiper-dev.com';
    case 'production':
    default:
      return 'https://client-api.formpiper.com';
  }
};

const axiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': getBaseApiUrl(),
  },
});

axiosInstance.defaults.baseURL = getBaseUrl();

export { axiosInstance };